import type { ComposerTranslation } from 'vue-i18n'
import { frequencyState, login_status, union } from './types'

/** 执行频率（与策略表单、其它模块枚举值一致） */
export function getFrequencyStateLabelMap (t: ComposerTranslation): Record<frequencyState, string> {
  return {
    [frequencyState.day]: t('terminalTrafficStateList.frequencyDay'),
    [frequencyState.week]: t('terminalTrafficStateList.frequencyWeek'),
    [frequencyState.month]: t('terminalTrafficStateList.frequencyMonth'),
  }
}

/** 终端在线状态（列表/筛选用） */
export function getLoginStatusLabelMap (t: ComposerTranslation): Record<login_status, string> {
  return {
    [login_status.online]: t('deviceStatus.online'),
    [login_status.offline]: t('deviceStatus.offline'),
  }
}

/** 流量单位（KB/MB 为通用符号，不随语言变化） */
export function getUnionLabelMap (): Record<union, string> {
  return {
    [union.KB]: 'KB',
    [union.MB]: 'MB',
  }
}
